import { AppEnvVariables } from "../../constants/environment.constants";
import { API_URL, MAX_API_TIMEOUT } from "../../constants/api.constants";
import { searchInitialState } from "../../store/slices/jobPricingSearchSlice";
import { kf1AuthenticatedHttpClient } from "kfone-frontend-core";

const getList = async (payLoad: any) => {
  return await kf1AuthenticatedHttpClient({
    method: "POST",
    url: `${AppEnvVariables.SJPR_API_URL}/api/listing/${payLoad?.category}`,
    headers: {
      "Content-type": "application/json"
      // authToken: AppEnvVariables.SJPR_AUTH_TOKEN
    },
    timeout: MAX_API_TIMEOUT,
    data: payLoad?.data
  });
};

export { getList };
